import { Link } from "react-router-dom";
import ScrollRevealText from "./ScrollRevealText.jsx";
import "./Statement.css";

export default function Statement({
  text = "Version3 is a software company building AI agents, automation and custom software around how your business actually runs.",
  tagline = "Built to scale, from day one.",
  paragraphs = [
    "From the first landing page to full products and automations, we ship software that grows with your business.",
    "We stay small on purpose, so you work directly with the people designing and building your product.",
  ],
  cta = { label: "Learn more", href: "/#services-stack" },
}) {
  return (
    <section className="st" id="about" data-nav-theme="light">
      <div className="st-inner">
        <ScrollRevealText as="p" className="st-text" text={text} />

        <div className="st-bottom">
          <p className="st-tagline">{tagline}</p>
          <div className="st-copy">
            {paragraphs.map((p) => (
              <p key={p}>{p}</p>
            ))}
            <Link className="arrow-link" to={cta.href}>
              <span className="arrow-link-l" aria-hidden="true">
                <span>↗︎</span>
              </span>
              <span className="arrow-link-text">{cta.label}</span>
              <span className="arrow-link-r" aria-hidden="true">
                <span>↗︎</span>
              </span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
